import { enableProdMode, ErrorHandler, importProvidersFrom, LOCALE_ID } from '@angular/core';

import {
  appConfigFactory,
  HttpLoaderFactory,
  RollbarErrorHandler,
  rollbarFactory,
  RollbarService,
  WELCOME_LAYOUT,
  welcomeLayoutFactory,
} from './app/app.module';
import { APP_CONFIG } from '@core/config/app-config.token';
import { environment } from './environments/environment';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { useridInterceptor } from '@core/interceptor/userid.interceptor';
import { LayoutModule } from './app/layout/layout.module';
import {
  bootstrapApplication,
  BrowserModule,
  HAMMER_LOADER,
  HammerModule,
} from '@angular/platform-browser';
import { AppRoutingModule } from './app/app.routing';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Logger } from '@shared/util/logger.util';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { AppComponent } from './app/app.component';
import { enableElfProdMode } from '@ngneat/elf';
import { appConfig } from './app.config';
import { resolveInitialTheme, themeClassOf } from '@core/services/theme/theme.service';
import { applyDeviceParams } from '@core/services/kiosk/kiosk';
import { saveDownloadsVia } from '@shared/util/file.util';

if (environment.production) {
  enableProdMode();
}
enableElfProdMode();
applyDeviceParams();

// a job app that runs only inside its fair's anymatch app goes there when opened on its own
const outsideItsApp = !!appConfig.app.embeddedIn && window.self === window.top;
if (outsideItsApp) {
  window.location.replace(appConfig.app.embeddedIn!);
} else if (appConfig.app.embeddedIn) {
  saveDownloadsVia(new URL(appConfig.app.embeddedIn).origin);
}

document.body.classList.add(themeClassOf(resolveInitialTheme(appConfig)));
if (appConfig.theme.logoShape === 'square') {
  document.body.classList.add('square-logos');
}

if (!outsideItsApp) {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        LayoutModule,
        BrowserModule,
        AppRoutingModule,
        HammerModule,
        NgIdleKeepaliveModule.forRoot(),
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
          },
        }),
        SharedModule,
        FlexModule,
        MatButtonModule,
      ),
      { provide: LOCALE_ID, useValue: 'de-DE' },
      { provide: HAMMER_LOADER, useValue: () => import('hammerjs') },
      { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
      provideHttpClient(withInterceptors([useridInterceptor])),
      { provide: ErrorHandler, useClass: RollbarErrorHandler },
      { provide: RollbarService, useFactory: rollbarFactory },
      { provide: APP_CONFIG, useFactory: appConfigFactory },
      { provide: WELCOME_LAYOUT, useFactory: welcomeLayoutFactory },
      provideAnimationsAsync(),
    ],
  }).catch((err) => Logger.error(err));
}
